export default __webpack_public_path__ + "static/media/scooterRed.ebecda06.png";